import React from 'react';
import { Container, Fade } from 'reactstrap';
import { PatientFormCard } from '../../../containers/Cards';
import {
  withRouter,
  matchPath,
  RouteComponentProps,
  generatePath,
} from 'react-router';
import OrganizationProvider from '../../../containers/Providers/Organizations';

const PatientEdit = (
  props: RouteComponentProps<{ organizationId: string; patientId: string }>,
) => {
  const path = '/organization/:organizationId/patient/:patientId';
  const match = matchPath<{ organizationId: string; patientId: string }>(
    props.location.pathname,
    {
      path: path,
    },
  );
  if (!match) return null;
  const gPath = generatePath(path, match.params);
  return (
    <OrganizationProvider organizationId={match && match.params.organizationId}>
      <Fade>
        <Container fluid className="mt-3">
          <Container>
            <PatientFormCard
              patientId={match.params.patientId}
              onComplete={() => props.history.push(gPath)}
            />
          </Container>
        </Container>
      </Fade>
    </OrganizationProvider>
  );
};
export default withRouter(PatientEdit);
